"use strict";

var _regeneratorRuntime = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/regenerator/index.js");
var _classCallCheck = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/createClass.js");
var _assertThisInitialized = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/assertThisInitialized.js");
var _inherits = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WalletConnect = exports.URI_AVAILABLE = void 0;
var types_1 = require("@web3-react/types");
var eventemitter3_1 = __importDefault(require("eventemitter3"));
var utils_1 = require("./utils");
exports.URI_AVAILABLE = 'URI_AVAILABLE';
var DEFAULT_TIMEOUT = 5000;
var WalletConnect = /*#__PURE__*/function (_types_1$Connector) {
  _inherits(WalletConnect, _types_1$Connector);
  var _super = _createSuper(WalletConnect);
  function WalletConnect(_ref) {
    var _this;
    var actions = _ref.actions,
      defaultChainId = _ref.defaultChainId,
      options = _ref.options,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? DEFAULT_TIMEOUT : _ref$timeout,
      onError = _ref.onError;
    _classCallCheck(this, WalletConnect);
    _this = _super.call(this, actions, onError);
    _this.events = new eventemitter3_1.default();
    _this.disconnectListener = function (error) {
      var _a;
      _this.actions.resetState();
      if (error) (_a = _this.onError) === null || _a === void 0 ? void 0 : _a.call(_assertThisInitialized(_this), error);
    };
    _this.chainChangedListener = function (chainId) {
      _this.actions.update({
        chainId: Number.parseInt(chainId, 16)
      });
    };
    _this.accountsChangedListener = function (accounts) {
      _this.actions.update({
        accounts: accounts
      });
    };
    _this.URIListener = function (uri) {
      _this.events.emit(exports.URI_AVAILABLE, uri);
    };
    var rpcMap = options.rpcMap,
      rpc = options.rpc,
      rest = __rest(options, ["rpcMap", "rpc"]);
    _this.options = rest;
    _this.defaultChainId = defaultChainId;
    _this.rpcMap = rpcMap || rpc;
    _this.timeout = timeout;
    var _this$getChainProps = _this.getChainProps(rest.chains, rest.optionalChains, defaultChainId),
      chains = _this$getChainProps.chains,
      optionalChains = _this$getChainProps.optionalChains;
    _this.chains = chains;
    _this.optionalChains = optionalChains;
    return _this;
  }
  _createClass(WalletConnect, [{
    key: "initializeProvider",
    value: function initializeProvider() {
      var desiredChainId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.defaultChainId;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var rpcMap, chainProps, ethProviderModule;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              rpcMap = this.rpcMap ? (0, utils_1.getBestUrlMap)(this.rpcMap, this.timeout) : undefined;
              chainProps = this.getChainProps(this.chains, this.optionalChains, desiredChainId);
              _context.next = 4;
              return Promise.resolve().then(function () {
                return __importStar(require('@walletconnect/ethereum-provider'));
              });
            case 4:
              ethProviderModule = _context.sent;
              _context.t0 = ethProviderModule.default;
              _context.t1 = Object;
              _context.t2 = Object.assign(Object.assign({}, this.options), chainProps);
              _context.next = 10;
              return rpcMap;
            case 10:
              _context.t3 = _context.sent;
              _context.t4 = {
                rpcMap: _context.t3
              };
              _context.t5 = _context.t1.assign.call(_context.t1, _context.t2, _context.t4);
              _context.next = 15;
              return _context.t0.init.call(_context.t0, _context.t5);
            case 15:
              this.provider = _context.sent;
              return _context.abrupt("return", this.provider.on('disconnect', this.disconnectListener).on('chainChanged', this.chainChangedListener).on('accountsChanged', this.accountsChangedListener).on('display_uri', this.URIListener));
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getChainProps",
    value: function getChainProps(chains, optionalChains) {
      var desiredChainId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.defaultChainId;
      // Reorder chains and optionalChains if necessary
      var orderedChains = (0, utils_1.getChainsWithDefault)(chains, desiredChainId);
      var orderedOptionalChains = (0, utils_1.getChainsWithDefault)(optionalChains, desiredChainId);
      // Validate and return the result.
      // Type discrimination requires that we use these typeguard checks to guarantee a valid return type.
      if ((0, utils_1.isArrayOneOrMore)(orderedChains)) {
        return {
          chains: orderedChains,
          optionalChains: orderedOptionalChains
        };
      } else if ((0, utils_1.isArrayOneOrMore)(orderedOptionalChains)) {
        return {
          chains: orderedChains,
          optionalChains: orderedOptionalChains
        };
      }
      throw new Error('Either chains or optionalChains must have at least one item.');
    }
  }, {
    key: "isomorphicInitialize",
    value: function isomorphicInitialize() {
      var desiredChainId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.defaultChainId;
      if (this.eagerConnection) return this.eagerConnection;
      return this.eagerConnection = this.initializeProvider(desiredChainId);
    }
    /** {@inheritdoc Connector.connectEagerly} */
  }, {
    key: "connectEagerly",
    value: function connectEagerly() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var cancelActivation, provider;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              cancelActivation = this.actions.startActivation();
              _context2.prev = 1;
              _context2.next = 4;
              return this.isomorphicInitialize();
            case 4:
              provider = _context2.sent;
              if (provider.session) {
                _context2.next = 7;
                break;
              }
              throw new Error('No active session found. Connect your wallet first.');
            case 7:
              this.actions.update({
                accounts: provider.accounts,
                chainId: provider.chainId
              });
              _context2.next = 16;
              break;
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](1);
              _context2.next = 14;
              return this.deactivate();
            case 14:
              cancelActivation();
              throw _context2.t0;
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 10]]);
      }));
    }
    /**
     * @param desiredChainId - The desired chainId to connect to.
     */
  }, {
    key: "activate",
    value: function activate(desiredChainId) {
      var _a;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var provider, isConnectedToDesiredChain, cancelActivation;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.isomorphicInitialize(desiredChainId);
            case 2:
              provider = _context3.sent;
              if (!provider.session) {
                _context3.next = 12;
                break;
              }
              if (!(!desiredChainId || desiredChainId === provider.chainId)) {
                _context3.next = 6;
                break;
              }
              return _context3.abrupt("return");
            case 6:
              // WalletConnect exposes connected accounts, not chains: `eip155:${chainId}:${address}`
              isConnectedToDesiredChain = provider.session.namespaces.eip155.accounts.some(function (account) {
                return account.startsWith("eip155:".concat(desiredChainId, ":"));
              });
              if (isConnectedToDesiredChain) {
                _context3.next = 11;
                break;
              }
              if (!((_a = this.options.optionalChains) === null || _a === void 0 ? void 0 : _a.includes(desiredChainId))) {
                _context3.next = 10;
                break;
              }
              throw new Error("Cannot activate an optional chain (".concat(desiredChainId, "), as the wallet is not connected to it.\n\tYou should handle this error in application code, as there is no guarantee that a wallet is connected to a chain configured in \"optionalChains\"."));
            case 10:
              throw new Error("Unknown chain (".concat(desiredChainId, "). Make sure to include any chains you might connect to in the \"chains\" or \"optionalChains\" parameters when initializing WalletConnect."));
            case 11:
              return _context3.abrupt("return", provider.request({
                method: 'wallet_switchEthereumChain',
                params: [{
                  chainId: "0x".concat(desiredChainId.toString(16))
                }]
              }));
            case 12:
              cancelActivation = this.actions.startActivation();
              _context3.prev = 13;
              _context3.next = 16;
              return provider.enable();
            case 16:
              this.actions.update({
                chainId: provider.chainId,
                accounts: provider.accounts
              });
              _context3.next = 25;
              break;
            case 19:
              _context3.prev = 19;
              _context3.t0 = _context3["catch"](13);
              _context3.next = 23;
              return this.deactivate();
            case 23:
              cancelActivation();
              throw _context3.t0;
            case 25:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[13, 19]]);
      }));
    }
    /** {@inheritdoc Connector.deactivate} */
  }, {
    key: "deactivate",
    value: function deactivate() {
      var _a;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              (_a = this.provider) === null || _a === void 0 ? void 0 : _a.removeListener('disconnect', this.disconnectListener).removeListener('chainChanged', this.chainChangedListener).removeListener('accountsChanged', this.accountsChangedListener).removeListener('display_uri', this.URIListener).disconnect();
              this.provider = undefined;
              this.eagerConnection = undefined;
              this.actions.resetState();
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
  }]);
  return WalletConnect;
}(types_1.Connector);
exports.WalletConnect = WalletConnect;